import styled from 'styled-components';

export const ScCopyCode = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 32px;
  color: #fff;

  & .code__btn {
    padding: 8px 16px;
    background-color: #ffffff20;
    border-radius: 40px;
    font-size: inherit;
    line-height: inherit;
    font-weight: 700;
    color: inherit;
    text-transform: inherit;
    cursor: pointer;
    transition:
      background-color 0.3s,
      color 0.3s;
    will-change: background-color, color;

    &:hover {
      background-color: #f4c134;
      color: #000;
    }
  }
`;
